import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck, Star } from 'lucide-react';
export function GuaranteeSection() {
  return <Section background="dark" className="relative overflow-hidden" data-id="element-64">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-65"></div>

      <div className="relative z-10 flex flex-col md:flex-row items-center gap-12 border border-[#FFD700]/30 bg-[#0B1A0B]/80 backdrop-blur-sm p-8 md:p-12 rounded-2xl" data-id="element-66">
        <div className="shrink-0 relative" data-id="element-67">
          <div className="w-40 h-40 md:w-48 md:h-48 bg-gradient-to-br from-[#FFD700] to-[#B8860B] rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(255,215,0,0.3)]" data-id="element-68">
            <div className="text-center text-[#0B1A0B]" data-id="element-69">
              <span className="block text-6xl md:text-7xl font-black leading-none" data-id="element-70">
                30
              </span>
              <span className="block text-sm font-bold uppercase tracking-wider" data-id="element-71">
                Días de
                <br data-id="element-72" />
                Garantía
              </span>
            </div>
          </div>
          <ShieldCheck className="absolute -bottom-4 -right-4 w-16 h-16 text-[#22C55E] fill-[#0B1A0B] bg-[#22C55E] rounded-full p-1" data-id="element-73" />
        </div>

        <div className="text-center md:text-left" data-id="element-74">
          <h2 className="text-2xl md:text-3xl font-bold text-white uppercase mb-4" data-id="element-75">
            GARANTÍA TOTAL VARAMAX:{' '}
            <span className="text-[#FFD700]" data-id="element-76">SIN RIESGO</span>
          </h2>
          <div className="flex justify-center md:justify-start gap-1 mb-4" data-id="element-77">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="fill-[#FFD700] text-[#FFD700] w-5 h-5" data-id="element-78" />)}
          </div>
          <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-79">
            Estamos tan seguros de que Varamax cambiará tu vida que te ofrecemos
            una garantía incondicional. Si en 30 días no ves los resultados que
            esperas, o simplemente no estás satisfecho, te devolvemos el 100% de
            tu dinero. Sin preguntas, sin letras pequeñas.
          </p>
          <button className="text-[#FF6B00] font-bold uppercase border-b-2 border-[#FF6B00] hover:text-white hover:border-white transition-colors pb-1" data-id="element-80">
            QUIERO EMPEZAR SIN RIESGO, ¡AHORA!
          </button>
        </div>
      </div>
    </Section>;
}